import { Outlet } from "react-router-dom";

const SiteConstructionManagementPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default SiteConstructionManagementPageLayout;
